import { render, staticRenderFns } from "./Vcard.vue?vue&type=template&id=57c57158&"
import script from "./Vcard.vue?vue&type=script&lang=js&"
export * from "./Vcard.vue?vue&type=script&lang=js&"
import style0 from "./Vcard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports